export default {
  forgot_password_submit: {
    title: 'Réinitialiser le mot de passe',
    submit_complete: 'Envoyé avec succès',
    password_reset: 'Le mot de passe a été réinitialisé',
  },
}
